import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";

export default function GalleryPage() {
  const [photos, setPhotos] = useState([]);
  const [lightbox, setLightbox] = useState(null);
  const { t } = useTranslation();

  useEffect(() => { api.get("/gallery").then((r) => setPhotos(r.data)); }, []);

  const sampleImages = [
    "https://images.unsplash.com/photo-1689672235271-727de51355e6?w=800",
    "https://images.unsplash.com/photo-1772730064951-89b427965dbc?w=800",
    "https://images.pexels.com/photos/8775053/pexels-photo-8775053.jpeg?w=800",
    "https://images.pexels.com/photos/17223838/pexels-photo-17223838.jpeg?w=800",
  ];

  const display = photos.length > 0 ? photos : sampleImages.map((url, i) => ({ id: `s${i}`, image_url: url, caption: "" }));

  return (
    <div className="pt-32 pb-12 min-h-screen" data-testid="gallery-page">
      <div className="container-tulsi">
        <div className="text-center mb-12">
          <p className="text-xs tracking-[0.4em] uppercase text-[#D11D21] mb-3">{t("gallery.subtitle")}</p>
          <h1 className="font-serif-display text-6xl text-gold-gradient">{t("gallery.title")}</h1>
          <div className="gold-separator" />
          <p className="mt-4 text-[#6B4A4E] max-w-xl mx-auto">{t("gallery.intro")}</p>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 space-y-4">
          {display.map((p, i) => (
            <motion.div key={p.id} initial={{ opacity: 0, scale: 0.95 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ delay: Math.min(i * 0.05, 0.4) }}
              className="break-inside-avoid rounded-2xl overflow-hidden border border-[#E8D9BE] cursor-pointer group"
              onClick={() => setLightbox(p)} data-testid={`gallery-item-${p.id}`}>
              <img src={p.image_url} alt={p.caption} className="w-full h-auto group-hover:scale-105 transition-transform duration-500" />
              {p.caption && <div className="p-3 text-sm text-[#6B4A4E] bg-[#FBEBD8]">{p.caption}</div>}
            </motion.div>
          ))}
        </div>

        {lightbox && (
          <div className="fixed inset-0 bg-black/80 backdrop-blur z-50 flex items-center justify-center p-6" onClick={() => setLightbox(null)} data-testid="lightbox">
            <img src={lightbox.image_url} alt="" className="max-w-full max-h-[90vh] rounded-2xl shadow-2xl" />
          </div>
        )}
      </div>
    </div>
  );
}
